// extracted by mini-css-extract-plugin
export default {"batchDivider":"_14teqyhN","batchDividerRule":"_1ABbe30D","batchDividerLabel":"_2PwtdTit"};